import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import '@vuepic/vue-datepicker/dist/main.css'; 
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import useAuth from './composables/useAuth';
import VueDatePicker from '@vuepic/vue-datepicker'; 
import setupInterceptors from './services/setupInterceptors';
import VueSweetAlert from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(fas, far, fab)
dom.watch();

const { checkAuth } = useAuth()

// router.beforeEach(async (to, from, next) => {
//     if(to.meta.requiresAuth){
//         if(!(await checkAuth())){
//             return next({name: 'Signin'})
//         }
//     }
//     else if(to.meta.guest){
//         if(await checkAuth()){
//             return next({name: 'mis-solicitudes'})
//         }
//     }
//     next()
// });

router.beforeEach(async (to, from, next) => {
  
    const isAuthenticated = await checkAuth();
  
    if (to.meta.requiresAuth && !isAuthenticated) {
      return next({ name: "Signin" });
    }
  
    if (to.meta.guest && isAuthenticated) {
      return next({ name: "mis-solicitudes" });
    }

    if (to.meta.requiresPersonalOrProfesional && isAuthenticated) {
      try {
        const storedRoles = localStorage.getItem("rol");
        const roles = storedRoles ? JSON.parse(storedRoles) : [];
        const hasAccess = roles && roles.some((r) => r.name === "PERSONAL" || r.name === "PROFESIONAL");
        if (!hasAccess) {
          return next({ name: "mis-solicitudes" });
        }
      } catch (e) {
        return next({ name: "mis-solicitudes" });
      }
    }

    if (to.meta.requiresProfesional && isAuthenticated) {
      try {
        const storedRoles = localStorage.getItem("rol");
        const roles = storedRoles ? JSON.parse(storedRoles) : [];
        const hasAccess = roles && roles.some((r) => r.name === "PROFESIONAL");
        if (!hasAccess) {
          return next({ name: "mis-solicitudes" });
        }
      } catch (e) {
        return next({ name: "mis-solicitudes" });
      }
    }

    if (to.meta.requiresPersonal && isAuthenticated) {
      try {
        const storedRoles = localStorage.getItem("rol");
        const roles = storedRoles ? JSON.parse(storedRoles) : [];
        const hasAccess = roles && roles.some((r) => r.name === "PERSONAL");
        if (!hasAccess) {
          return next({ name: "mis-solicitudes" });
        }
      } catch (e) {
        return next({ name: "mis-solicitudes" });
      }
    }
  
    next();
  });

setupInterceptors(store);

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueSweetAlert);
appInstance.mount("#app");
appInstance.component('VueDatePicker', VueDatePicker) 
appInstance.component("font-awesome-icon", FontAwesomeIcon)

